import React from 'react'
import AxiosNews from './AxiosNews'
import News from './News'
import styles from './api.css'

const Api = () => {
  const newsObj = {
    category: 'business',
    country: 'gb',
    type: 'top-headlines',
  }
  const newsObjUs = {
    category: 'business',
    country: 'us',
    type: 'top-headlines',
  }
  return (
    <main className={styles['api-wrapper']}>
      <h3>Api Check</h3>
      <section className={styles['api-content']}>
        <h4>Axios News</h4>
        <AxiosNews
          category={newsObjUs.category}
          country={newsObjUs.country}
          type={newsObjUs.type}
        />
        <hr />
        <h4>Fetch News</h4>
        <News
          category={newsObj.category}
          country={newsObj.country}
          type={newsObj.type}
        />
      </section>
    </main>
  )
}

export default Api
